import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap';
import { AtxDropdownComponent } from './components/atx-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        BsDropdownModule,
    ],
    declarations: [
        AtxDropdownComponent,
    ],
    exports: [
        AtxDropdownComponent,
    ],
})

export class AtxDropdownModule {}
